export default "__VITE_ASSET___8zlg0YJ__"